<template>
  <ul>
    <li
      v-for="(itemAside, index) in itemsAsideMenu"
      :key="index"
    >
      <router-link
        :class="itemAside.class"
        :to="itemAside.to"
      >
        <span class="m-item-aside-icon">
          <i :class="itemAside.icon"></i>
        </span>
        <span>{{ itemAside.text }}</span>
      </router-link>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'AtomEditionSectionNavigationMenu',

  props: {
    itemsAsideMenu: Array
  }
}
</script>
